import { z } from 'zod';

const AdobeConfigObj = z.object({
  profile: z.string(),
  key: z.string(),
});
export const TokenOptionsSchema = z.object({
  detailedResponse: z.boolean().optional(),
  cacheMode: z.string().optional(),
});

export const AllowedListEntrySchema = z.object({
  tokenOptions: TokenOptionsSchema.optional(),
  uri: z.string().optional(),
});

export const HttpInterceptorConfigSchema = z.object({
  allowedList: z.array(AllowedListEntrySchema).optional(),
});

export const TenantConfigSchema = z.object({
  domain: z.string(),
  clientId: z.string(),
  legacySameSiteCookie: z.boolean().optional(),
  cookieDomain: z.string().optional(),
  useRefreshTokens: z.boolean().optional(),
  useRefreshTokensFallback: z.boolean().optional(),
  cacheLocation: z.string().optional(),
  authorizationParams: z
    .object({
      redirect_uri: z.string().optional(),
      cacheLocation: z.string().optional(),
      useCache: z.boolean().optional(),
      audience: z.string().optional(),
    })
    .optional(),
  leeway: z.number().optional(),
  httpInterceptor: HttpInterceptorConfigSchema.optional(),
  auraProfileApiKey: z.string().optional(),
});
const AppSwitcherPortalsSchema = z.object({
  apps: z.object({ dashboard: z.string(), signUp: z.string().optional() }),
  rscom: z.object({ dashboard: z.string(), signUp: z.string() }),
  cor1: z.object({
    dashboard: z.string(),
    signUp: z.string(),
  }),
  cor2: z.object({
    dashboard: z.string(),
    signUp: z.string(),
  }),
  sw: z.object({ dashboard: z.string(), signUp: z.string() }),
  na: z.object({ dashboard: z.string(), signUp: z.string() }),
  profile: z.object({ dashboard: z.string(), signUp: z.string().optional() }),
  boa: z.object({ dashboard: z.string(), signUp: z.string().optional() }),
});
export const Environment = z.object({
  production: z.boolean(),
  trackjsToken: z.string().optional(),
  adobeConfig: z.array(AdobeConfigObj).optional(),
  applyAdobeFix: z.boolean().optional(),
  classicUiHost: z.string().optional(),
  coveoClientId: z.string().optional(),
  coveoEndpoint: z.string().optional(),
  defaultTokenEndpoint: z.string().optional(),
  platformUrl: z.string().optional(),
  searchHub: z.string().optional(),
  organizationId: z.string().optional(),
  fisEndpoint: z.string().optional(),
  apigeeApiKey: z.string().optional(),
  apiKey: z.string().optional(),
  paymentFormEndpoint: z.string().optional(),
  //@AURA
  tenantConfig: TenantConfigSchema.optional(),
  appSwitcherRootUrl: z.string().optional(),
  appSwitcherPortals: AppSwitcherPortalsSchema.optional(),
  auraProfileApiKey: z.string().optional(),
  auraReportingApiKey: z.string().optional(),
});

export type AppSwitcherPortals = z.infer<typeof AppSwitcherPortalsSchema>;
export type TenantConfig = z.infer<typeof TenantConfigSchema>;
export type Environment = z.infer<typeof Environment>;
